import { render, staticRenderFns } from "./InfoBar.vue?vue&type=template&id=7cfdb4ca"
import script from "./InfoBar.vue?vue&type=script&lang=ts"
export * from "./InfoBar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports